'use client';

import { Unlock } from 'lucide-react';
import dynamic from 'next/dynamic';
import { ReactNode, useState } from 'react';
import {
  Amount,
  Container,
  Copy,
  Monthly,
  Payment,
  PriceDetails
} from './VehicleSlider.styles';

const InfiniteSlider = dynamic(() => import('./InfiniteSlider'), {
  ssr: false
});

type TransitionProps = {
  currentChild: number;
};

type OwnProps = {
  children: ReactNode[];
  priceDetails: number[];
};

export default function VehicleSliderCarousel({
  children,
  priceDetails
}: OwnProps) {
  const [showPriceDetails, setShowPriceDetails] = useState<boolean>(true);
  const [priceDetail, setPriceDetail] = useState<number>(priceDetails[2]);

  const getPriceDetail = (childIndex: number) => {
    childIndex = childIndex >= priceDetails.length ? 0 : childIndex;

    return priceDetails[childIndex];
  };

  const onTransitionStart = () => {
    setShowPriceDetails(false);
  };

  const onTransitionEnd = ({ currentChild }: TransitionProps) => {
    setPriceDetail(getPriceDetail(currentChild));
    setShowPriceDetails(true);
  };

  return (
    <Container>
      <InfiniteSlider
        delay={4000}
        transformDuration={800}
        onTransitionStart={onTransitionStart}
        onTransitionEnd={onTransitionEnd}
      >
        {children}
      </InfiniteSlider>

      <PriceDetails show={showPriceDetails}>
        <Unlock className="shrink-0" color="white" size={27} />
        <Copy>
          <Payment>Real Payment</Payment>
          <Amount>
            ${priceDetail.toLocaleString()}
            <Monthly>/mo*</Monthly>
          </Amount>
        </Copy>
      </PriceDetails>
    </Container>
  );
}
